import React from 'react';
import { View, ScrollView, Text, Image } from 'react-native';

import styles from './styles';
import { FormattedMessage } from 'react-intl';

const CardsCashback = () => {
    return (
        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
            <View style={styles.contentCard}>
                <View style={styles.contentHeaderCard}>
                    <Text style={styles.percentage}>
                    <FormattedMessage id='cardscashback.15%'/>
                    </Text>
                    <Text style={styles.textCashback}>
                    <FormattedMessage id='cardscashback.cashback'/>
                        </Text>
                </View>
                <Text style={styles.descriptionCashback}>
                <FormattedMessage id='cardscashback.abasteca'/>
                </Text>
                <Image source={require('../../../assets/imgs/cashbackShell.png')} style={styles.imgCashback} />
                <Text style={styles.more}>
                <FormattedMessage id='cardscashback.saibaMais'/>
                </Text>
            </View>

            <View style={styles.contentCard}>
                <View style={styles.contentHeaderCard}>
                    <Text style={styles.percentage}>
                    <FormattedMessage id='cardscashback.30%'/>
                    </Text>
                    <Text style={styles.textCashback}>
                    <FormattedMessage id='cardscashback.cashback'/>
                        </Text>
                </View>
                <Text style={styles.descriptionCashback}>
                <FormattedMessage id='cardscashback.oMarketlace'/>
                    
                </Text>
                <Image source={require('../../../assets/imgs/cashbackMarketplace.png')} style={styles.imgCashback} />
                <Text style={styles.more}>
                <FormattedMessage id='cardscashback.saibaMais'/>
                    </Text>
            </View>

            <View style={styles.contentCard}>
                <View style={styles.contentHeaderCard}>
                    <Text style={styles.percentage}><FormattedMessage id='cardscashback.55%'/></Text>
                    <Text style={styles.textCashback}>
                    <FormattedMessage id='cardscashback.cashback'/>
                    </Text>
                </View>
                <Text style={styles.descriptionCashback}>
                <FormattedMessage id='cardscashback.imperdivel'/>
                    
                </Text>
                <Image source={require('../../../assets/imgs/cashbackShell.png')} style={styles.imgCashback} />
                <Text style={styles.more}>
                <FormattedMessage id='cardscashback.saiba mais'/>
                </Text>
            </View>
        </ScrollView>
    );
}

export default CardsCashback;